import React, { useState } from "react";
import "./Form.css";
import axios from "axios"; // Add this import

const Form = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    visa: "",
  });

  const [isSent, setIsSent] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setIsSent(false);
  setError(null);

  try {
    const response = await axios.post("https://overseas-backend-1-548y.onrender.com/api/formpage", formData);

    if (response.status === 200) {
      setIsSent(true);
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
        visa: "",
      });
    } else {
      throw new Error("Failed to send message. Please try again.");
    }
  } catch (err) {
    console.error(err);
    setError(err.response?.data?.error || "Something went wrong. Please try again.");
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="form">
      <div className="form-container">
        <h2 className="form-title">Free Online Assessment</h2>
        <form className="assessment-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Name"
            className="form-input"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            className="form-input"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Message"
            className="form-textarea"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
          <input
            type="tel"
            name="phone"
            placeholder="Phone"
            className="form-input"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <select
            name="visa"
            className="form-select"
            value={formData.visa}
            onChange={handleChange}
            required
          >
            <option value="">Select Visa</option>
            <option value="Student Visa">Student Visa</option>
            <option value="Work Visa">Work Visa</option>
            <option value="Tourist Visa">Tourist Visa</option>
          </select>

          <button type="submit" className="form-button" disabled={loading}>
            {loading ? <div className="spinner"></div> : "Submit"}
          </button>

          {isSent && <p className="success-msg">✅ Message sent successfully!</p>}
          {error && <p className="error-msg">❌ {error}</p>}
        </form>
      </div>
    </div>
  );
};

export default Form;
